import { DisciplineAcademicResults } from 'pages/corporate_reports/DisciplineAcademicResults';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports/discipline_academic_results',
  route: 'discipline_academic_results',
  label: 'Resultados Acadêmicos por Disciplina',
  parentName: 'corporate_reports',
  list: DisciplineAcademicResults,
  actions: ['list', 'export']
};

export default generateResources(resource);
